import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title4 } from "@components/Typography";
import { useErrorBanner, useGoals, useModal, usePauseSip, useSuccessBanner } from "@hooks";
import { i18n, Translations } from "@i18n";
import { EditRecurringContributionModalProps } from "@routes/TransfersRoute/TransactionList/EditRecurringContributionModal/types";

export const PauseContributionModal = ({ item }: EditRecurringContributionModalProps) => {
  const { dismiss } = useModal();
  const { showErrorBanner } = useErrorBanner();
  const { showSuccessBanner } = useSuccessBanner();

  const { goals } = useGoals();

  const sipId = goals.find((g) => g.id === item.goalId)?.sips?.[0]?.id;

  const [pauseSip, { loading }] = usePauseSip();

  const handleSubmit = async () => {
    if (!sipId) return showErrorBanner();

    try {
      await pauseSip({
        variables: {
          sipId,
        },
      });

      dismiss();
      showSuccessBanner(i18n.t(Translations.PauseContributionSuccessMessage));
    } catch (e: any) {
      const message = e.graphQLErrors?.[0]?.message;
      showErrorBanner(message);
    }

    dismiss();
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.PauseContributionModalPrimaryCTA),
        onClick: handleSubmit,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.PauseContributionModalSecondaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Title4>{i18n.t(Translations.PauseContributionModalTitle)}</Title4>
      <Spacing size={SpacingSizes.M} />
      <Body>{i18n.t(Translations.PauseContributionModalSubtitle)}</Body>
      <Spacing size={SpacingSizes.XL} />
    </Overlay>
  );
};
